module.exports = __webpack_public_path__ + "static/media/default_profile.9464d298.svg";